import { type SxProps, type Theme } from "@mui/material";

import { Box } from "ui/box/box";
import { Chip } from "ui/chip/chip";
import { TextField } from "ui/text-field/text-field";
import { getCounter } from "ui/text-field/text-field.helpers";
import { type TextFieldProps } from "ui/text-field/text-field.types";

const DEFAULT_MAX_LENGTH = 32;

// inline-flex, not flex: FormLabel renders the required asterisk as a sibling right after this
// label node, and a block-level flex row would push that asterisk onto its own line.
const COUNTER_ROW_SX: SxProps<Theme> = {
  display: "inline-flex",
  alignItems: "center",
  gap: 1,
};

export type TextFieldWithCounterProps = TextFieldProps & {
  maxLength?: number;
};

export const TextFieldWithCounter = ({
  value,
  maxLength = DEFAULT_MAX_LENGTH,
  label,
  required,
  disabled,
  ref,
  ...rest
}: TextFieldWithCounterProps) => {
  const counter = getCounter(value, maxLength);

  const labelWithCounter = (
    <Box sx={COUNTER_ROW_SX}>
      <Box component="span">{label}</Box>
      <Chip
        color={counter.color}
        size="small"
        variant="filled"
        label={counter.label}
      />
    </Box>
  );

  return (
    <TextField
      ref={ref}
      value={value}
      label={labelWithCounter}
      required={required}
      disabled={disabled}
      {...rest}
    />
  );
};
